enum WebVisitsReportingRequest {
  Date = 'ATTRIBUTION_BID_DAY',
  Device = 'ATTRIBUTION_DEVICE',
  Channel = 'ATTRIBUTION_CHANNEL',
  Campaign = 'ATTRIBUTION_CAMPAIGN',
  Creative = 'ATTRIBUTION_CREATIVE',
  Publisher = 'ATTRIBUTION_PUBLISHER',
  Placement = 'ATTRIBUTION_PLACEMENT',
  Daypart = 'ATTRIBUTION_DAYPART',
  DayOfWeek = 'ATTRIBUTION_DAY_OF_WEEK',
  Zip = 'ATTRIBUTION_ZIP',
  County = 'ATTRIBUTION_COUNTY',
  State = 'ATTRIBUTION_STATE',
  Congressional = 'ATTRIBUTION_CONGRESSIONAL',
  City = 'ATTRIBUTION_CITY',
  Dma = 'ATTRIBUTION_DMA',
  Pixel = 'ATTRIBUTION_PIXEL',
}

export default WebVisitsReportingRequest;
